module.exports = __webpack_public_path__ + "img/Fondo_Menu_inferior.bc0d9aae.svg";